"use client";

import AutoIncrementCounter from "@/components/AutoIncrementCounter/AutoIncrementCounter";
import React from "react";

const SingularGetSamplesBannerClient = React.memo(() => {
  return (
    <p className="text-lg lg:text-xl hidden md:inline">
      Launching in over{" "}
      <AutoIncrementCounter
        target={1047}
        duration={2000}
        className="font-semibold translate-y-1/2 text-golden-lemon"
      />{" "}
      dispensaries
    </p>
  );
});

SingularGetSamplesBannerClient.displayName = 'SingularGetSamplesBannerClient';

export default SingularGetSamplesBannerClient;

